import { fetchBasicGetJson, fetchBasicUrlGetJson } from "@/script/common";

var units = [];
async function getUnits() {
    if (units.length === 0) {
        units = (await fetchBasicGetJson('/Unit/GetData')).data;
    }
    return [...units];
};
export default {
    data: (function () {
        return {
            async byId(id) {
                return (await getUnits()).find(x => x.id === id);
            },
            async byTypes(types) {
                return (await getUnits()).filter(x => types.includes(x.unitType));
            },
            async byType(type) {
                return (await getUnits()).filter(x => x.unitType === type);
            },
            async all() {
                return await getUnits();
            }
        }
    })(),
    getData: (filter, signal) =>
        fetchBasicUrlGetJson('/Unit/GetData', { data: filter, signal: signal }, { useBlock: !signal })
}